'use client';

import { c as _c } from "react/compiler-runtime";
import { Button } from '@common/components';
import { Pagination } from '@common/components/molecule/Pagination';
interface SearchResultMeta {
  totalCount?: number;
  totalPages?: number;
  hasNext?: boolean;
}
interface SearchSectionShellProps {
  meta?: SearchResultMeta;
  page: number;
  pageSize: number;
  onPageChange: (page: number) => void;
  /** 결과 영역(스켈레톤/리스트/빈 상태). 호출자가 isLoading 분기 책임. */
  children: React.ReactNode;
  header?: React.ReactNode;
}
export function SearchSectionShell(t0) {
  const $ = _c(24);
  const {
    meta,
    page,
    pageSize,
    onPageChange,
    children,
    header
  } = t0;
  let t1;
  if ($[0] !== meta) {
    t1 = typeof meta?.totalCount === "number" ? `전체 ${meta.totalCount.toLocaleString()}건` : "\uAC80\uC0C9 \uACB0\uACFC";
    $[0] = meta;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <p className="font-700 text-Gray-black typo-body4 mobile-tablet:font-500">{t1}</p>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== header || $[5] !== t2) {
    t3 = <div className="flex items-center justify-between py-10 mobile-tablet:px-20">{t2}{header}</div>;
    $[4] = header;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== children) {
    t4 = <div className="flex flex-1 flex-col">{children}</div>;
    $[7] = children;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== meta || $[10] !== onPageChange || $[11] !== page || $[12] !== pageSize) {
    t5 = meta?.totalPages && meta.totalPages > 1 ? <Pagination totalCount={meta.totalCount ?? 0} currentPage={page} size={pageSize} onMovePage={onPageChange} perButtonCount={5} className="my-0 pb-40" /> : null;
    $[9] = meta;
    $[10] = onPageChange;
    $[11] = page;
    $[12] = pageSize;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== meta?.hasNext || $[15] !== meta?.totalPages || $[16] !== onPageChange || $[17] !== page) {
    t6 = !meta?.totalPages && (page > 1 || meta?.hasNext) ? <div className="flex items-center justify-center gap-8 pb-40 pt-24"><Button type="button" theme="secondary-fill" dimensions="H40" disabled={page < 2} onClick={() => onPageChange(page - 1)}>이전</Button><Button type="button" dimensions="H40" disabled={!meta?.hasNext} onClick={() => onPageChange(page + 1)}>다음</Button></div> : null;
    $[14] = meta?.hasNext;
    $[15] = meta?.totalPages;
    $[16] = onPageChange;
    $[17] = page;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  let t7;
  if ($[19] !== t3 || $[20] !== t4 || $[21] !== t5 || $[22] !== t6) {
    t7 = <section className="flex w-full min-w-0 flex-1 flex-col">{t3}{t4}{t5}{t6}</section>;
    $[19] = t3;
    $[20] = t4;
    $[21] = t5;
    $[22] = t6;
    $[23] = t7;
  } else {
    t7 = $[23];
  }
  return t7;
}